// Tipi e utility di adattamento tra il backend (DocumentNode) e Cubone
// (`@cubone/react-file-manager`), che identifica i nodi via `path` string.

export type DocumentNodeBE = {
  id: number;
  name: string;
  node_type: 'FILE' | 'FOLDER';
  parent: number | null;
  file?: string | null;
  file_size?: number | null;
  created_at: string;
  uploaded_by?: string | null;
  children: DocumentNodeBE[];
  index_status?: 'pending' | 'indexing' | 'indexed' | 'unsupported' | 'extraction_failed' | 'too_large' | 'failed' | null;
  index_reason_code?: string | null;
  index_reason?: string | null;
  index_updated_at?: string | null;
  indexed_at?: string | null;
};

export type CuboneFile = {
  name: string;
  isDirectory: boolean;
  path: string;
  updatedAt?: string;
  size?: number;
  _id: number;
  indexStatus?: DocumentNodeBE['index_status'];
  indexReasonCode?: string | null;
  indexReason?: string | null;
  indexUpdatedAt?: string | null;
  indexedAt?: string | null;
  uploadedBy?: string | null;
};

export function flattenTree(
  nodes: DocumentNodeBE[],
  prefix = ''
): { files: CuboneFile[]; pathToId: Map<string, number> } {
  const files: CuboneFile[] = [];
  const pathToId = new Map<string, number>();

  for (const n of nodes) {
    const path = `${prefix}/${n.name}`;
    pathToId.set(path, n.id);
    files.push({
      name: n.name,
      isDirectory: n.node_type === 'FOLDER',
      path,
      updatedAt: n.created_at,
      uploadedBy: n.uploaded_by,
      size: n.file_size ?? undefined,
      _id: n.id,
      indexStatus: n.index_status,
      indexReasonCode: n.index_reason_code,
      indexReason: n.index_reason,
      indexUpdatedAt: n.index_updated_at,
      indexedAt: n.indexed_at,
    });
    if (n.children && n.children.length > 0) {
      const sub = flattenTree(n.children, path);
      files.push(...sub.files);
      for (const [k, v] of sub.pathToId) pathToId.set(k, v);
    }
  }
  return { files, pathToId };
}
